import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';

const deviceSetup = Loadable(() => import('../../containers/web/deviceSetup'));
export default MapTo('vcg/components/soe-home/react/devicesetup')(deviceSetup);
